


export default class {
    constructor($el) {
        this.$ = $el;
        this.$inp = $el.find('input');
        this.data = $el.data('search');
        this.xVisible = null;
        this.timeout = null;
        this.$x = this.createX();
        this.$form = $el.parents('form');
        this.$button = this.$form.find('[type="submit"]');
        this.originalButtonText = this.$button.text();
        this.$inp.keyup(()=>{
            this.checkInput();
        });
        this.checkInput();
        this.$x.click(()=>{
            this.xClick();
        });
    }
    checkInput() {
        if (this.timeout !== null) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        this.timeout = setTimeout(()=>{
            let val = this.$inp.val();
            if (val) {
                if (this.xVisible !== true) {
                    this.showX();
                }
            } else {
                if (this.xVisible !== false) {
                    this.hideX();
                }
            }
        }, 500);
    }
    hideX() {
        this.xVisible = false;
        this.$x.removeClass('-show');
    }
    showX() {
        this.xVisible = true;
        this.$x.addClass('-show');
        this.$button.text(this.originalButtonText);
    }
    createX() {
        let $x = $('<img alt="Clear search" class="-x" src="/app/themes/hoban/resources/assets/images/graphic-sml/x-blue.svg" />');
        this.$inp.after($x);
        return $x;
    }
    xClick() {
        if (this.xVisible) {
            this.$inp.val('');
            this.hideX();
            if ( ! this.data.all) {
                this.$button.text('Show All');
            }
            this.$inp.focus();
        }
    }
}



// WEBPACK FOOTER //
// ./scripts/lib/SearchField.js